(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_article-video-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const namespace = 'ArticleTemplateVideoBlocks';

    if (window[namespace]) {
      window[namespace].hydrate();
      return;
    }

    const mediaQuery = window.matchMedia('(max-width: 900px)');

    const mount = (root) => {
      const device = mediaQuery.matches ? 'mobile' : 'desktop';
      const stage = root.querySelector('[data-article-video-stage]');
      const template = root.querySelector(`[data-article-video-template="${device}"]`);

      if (!stage || !template || root.dataset.articleVideoDevice === device) return;

      stage.querySelectorAll('video').forEach((video) => video.pause());
      stage.replaceChildren(template.content.cloneNode(true));
      root.dataset.articleVideoDevice = device;
    };

    const hydrate = (scope = document) => {
      if (scope.matches?.('[data-article-video-item]')) mount(scope);
      scope.querySelectorAll?.('[data-article-video-item]').forEach(mount);
    };

    let resizeFrame;
    const handleResize = () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => hydrate());
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-article-video-play]');
      if (!button) return;

      const view = button.closest('[data-article-video-view]');
      const template = view?.querySelector('[data-article-video-playback-template]');
      if (!view || !template) return;

      view.replaceChildren(template.content.cloneNode(true));
      const video = view.querySelector('video');
      if (video) video.play().catch(() => {});
    });

    window.addEventListener('resize', handleResize, { passive: true });
    document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
    document.addEventListener('shopify:block:select', (event) => hydrate(event.target));

    window[namespace] = { hydrate };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => hydrate(), { once: true });
    } else {
      hydrate();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
